import { useEffect, useState } from "react";
import { Bell, Inbox, MessageSquare, Flag, ShieldAlert, Clock } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { parentApi } from "../../lib/api";
import { timeAgo } from "../../lib/constants";

const ICON = { pending_video: Inbox, pending_comment: MessageSquare, report: Flag, blocked: ShieldAlert, screen_time: Clock };

export const NotificationBell = () => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = () => parentApi.get("/parent/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, []);

  const onOpen = (o) => {
    if (o && data.unread) parentApi.post("/parent/notifications/read-all").then(() => setData((d) => ({ ...d, unread: 0 })));
  };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notifications-bell" className="relative w-11 h-11 grid place-items-center rounded-full border-[3px] border-[#1B1A2E] bg-white hover:bg-[#FFD23F] transition-colors" title="Notifications">
          <Bell size={18} />
          {data.unread > 0 && <span data-testid="notifications-unread" className="absolute -top-1 -right-1 bg-[#FF6B4A] text-white text-[10px] font-bold rounded-full min-w-5 h-5 px-1 grid place-items-center border-2 border-[#1B1A2E]">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" data-testid="notifications-panel" className="w-80 border-[3px] border-[#1B1A2E] rounded-2xl shadow-[5px_5px_0_0_#1B1A2E] p-2 max-h-[70vh] overflow-y-auto">
        <p className="font-display font-semibold text-lg px-2 py-1">Notifications</p>
        {data.items.length === 0 && <p className="text-sm px-2 py-4 text-[#1B1A2E]/60">You're all caught up.</p>}
        {data.items.map((n) => {
          const Icon = ICON[n.kind] || Bell;
          return (
            <div key={n.id} className={`flex gap-3 p-2 rounded-xl ${n.read ? "" : "bg-[#FFF7EC]"}`}>
              <Icon size={18} className="mt-1 shrink-0" />
              <div className="min-w-0"><p className="font-semibold text-sm">{n.title}</p><p className="text-sm text-[#1B1A2E]/70 break-words">{n.body}</p><p className="text-xs text-[#1B1A2E]/50">{timeAgo(n.created_at)}</p></div>
            </div>
          );
        })}
      </PopoverContent>
    </Popover>
  );
};
